import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

// Section components (reused from home page)
import { HeroSection } from '../home/components/hero-section/hero-section';
import { ProcessSection } from '../home/components/process-section/process-section';
import { StyleSection } from '../home/components/style-section/style-section';
import { CreateSection } from '../home/components/create-section/create-section';
import { FaqSection } from '../home/components/faq-section/faq-section';
import { InspireSection } from '../home/components/inspire-section/inspire-section';
import { ProductsSection } from '../home/components/products-section/products-section';
import { TestimonialsSection } from '../home/components/testimonials-section/testimonials-section';

// New ad-specific section
import { BannerSection } from './components/banner-section/banner-section';
import { PromoSection } from './components/promo-section/promo-section';

@Component({
  selector: 'app-ad-page',
  imports: [
    CommonModule,
    // Section components
    HeroSection,
    ProcessSection,
    StyleSection,
    CreateSection,
    FaqSection,
    InspireSection,
    ProductsSection,
    TestimonialsSection,
    BannerSection,
    PromoSection,
  ],
  templateUrl: './ad.page.html',
  styleUrl: './ad.page.scss',
})
export class AdPage {
}
